import { SimpleCenterLayout } from "@mnk/frontend/components/layouts/SimpleCenterLayout";
import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { Success } from "@mnk/frontend/components/ui/flashMessage/Success";
import { useState } from "react";
import { trpc } from "../../lib/trpc";

export const PasswordForgot = () => {
  const [email, setEmail] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const requestResetPasswordMutation = trpc.requestResetPassword.useMutation();

  return (
    <SimpleCenterLayout>
      <h2 className="text-xl font-bold text-center">パスワードリセット</h2>

      {success ? (
        <div className="mt-4">
          <Success message="パスワードリセットのメールを送信しました" />
          <p className="text-sm text-gray-500 text-center mt-4">
            メールに記載されたリンクからパスワードの再設定を行ってください。
          </p>
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-2 my-4 px-2">
            <label htmlFor="email" className="text-sm text-gray-500">
              メールアドレス
            </label>
            <input
              id="email"
              type="email"
              className="border border-gray-300 rounded-md p-2"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {error && <p className="text-sm text-red-500 text-center">{error}</p>}

          <PrimaryButton
            onClick={async (e) => {
              e.preventDefault();
              try {
                setProcessing(true);
                await requestResetPasswordMutation.mutateAsync({ email });
                setSuccess(true);
              } catch (error) {
                setError("メールの送信に失敗しました");
              } finally {
                setProcessing(false);
              }
            }}
            className="mt-8 w-full"
            disabled={processing || !email}
          >
            リセットリンクを送信
          </PrimaryButton>
        </>
      )}
    </SimpleCenterLayout>
  );
};
